import { defineQuery as l } from "bitecs";
import "../../core/ecs/components.js";
import * as D from "three";
import "../../core/validation/schemas.js";
import { Transform as d, WorldTransform as c } from "../transforms/components.js";
import "../transforms/systems.js";
import { OrbitCamera as o } from "./components.js";
import { InputState as r } from "../input/components.js";
import "../input/systems.js";
import { smoothCameraRotation as w, calculateCameraPosition as E, updateCameraTransform as x } from "./operations.js";
const g = l([o, d]), M = l([o]), b = l([r]), Z = {
  group: "setup",
  update: (e) => {
    const a = g(e.world);
    for (const t of a) {
      if (o.target[t] === 0) {
        const n = e.createEntity();
        e.addComponent(n, d, {
          scaleX: 1,
          scaleY: 1,
          scaleZ: 1
        }), o.target[t] = n;
      }
      if (o.inputSource[t] === 0) {
        const n = b(e.world);
        if (n.length > 0)
          o.inputSource[t] = n[0];
        else {
          const i = e.createEntity();
          e.addComponent(i, r), o.inputSource[t] = i;
        }
      }
    }
  }
}, R = {
  group: "simulation",
  update: (e) => {
    const a = M(e.world);
    for (const t of a) {
      let n = o.inputSource[t];
      if (!n && e.hasComponent(t, r) && (n = t, o.inputSource[t] = t), !n || !e.hasComponent(n, r))
        continue;
      const i = o.sensitivity[t], s = o.zoomSensitivity[t], y = r.lookX[n], S = r.lookY[n], h = r.scrollDelta[n];
      if (r.rightMouse[n] === 1) {
        o.targetYaw[t] -= y * i;
        const u = o.targetPitch[t] + S * i, p = o.minPitch[t], f = o.maxPitch[t];
        o.targetPitch[t] = Math.max(
          p,
          Math.min(f, u)
        );
      }
      if (h !== 0) {
        const m = o.targetDistance[t], u = o.minDistance[t], p = o.maxDistance[t], f = Math.max(0.3, m * 0.08), C = h * s * f, P = m + C;
        o.targetDistance[t] = Math.max(
          u,
          Math.min(p, P)
        );
      }
    }
  }
}, V = {
  group: "draw",
  update: (e) => {
    const a = g(e.world);
    for (const t of a) {
      const n = o.target[t];
      if (!n || !e.hasComponent(n, c))
        continue;
      w(t, e.time.deltaTime);
      const i = new D.Vector3(
        c.posX[n] + o.offsetX[t],
        c.posY[n] + o.offsetY[t],
        c.posZ[n] + o.offsetZ[t]
      ), s = E(
        t,
        i
      );
      x(t, s, i);
    }
  }
};
export {
  R as OrbitCameraInputSystem,
  Z as OrbitCameraSetupSystem,
  V as OrbitCameraSystem
};
//# sourceMappingURL=systems.js.map
